import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Common/Header";
import Footer from "../../Components/Common/Footer";
import { Helmet } from "react-helmet-async";
import config from "../../config";
import draftToHtml from "draftjs-to-html";

const FAQ = () => {
  const [allFAQ, setAllFAQ] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const faqPerPage = 6;
  const elRefs = useRef({});

  useEffect(() => {
    const fetchAllFAQ = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/faqs`);
        if (!response.ok) throw new Error("Failed to fetch faq data");
        const result = await response.json();
        if (result.status === "success" && result.data.length > 0) {
          setAllFAQ(result.data);
        } else {
          setError("No data found");
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchAllFAQ();
  }, []);

  // Pagination Logic
  const indexOfLastfaq = currentPage * faqPerPage;
  const indexOfFirstfaq = indexOfLastfaq - faqPerPage;
  const currentFAQ = allFAQ.slice(indexOfFirstfaq, indexOfLastfaq);
  const totalPages = Math.ceil(allFAQ.length / faqPerPage);

  const toggleAccordion = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleClick = (pageNumber) => setCurrentPage(pageNumber);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  return (
    <div>
      <Helmet>
        <title>FAQs | Corpquick</title>
        <meta
          name="answer"
          content="Explore our latest faqs and articles on various topics. Stay updated with the latest trends and insights."
        />
      </Helmet>
      <Header />
      <div className="common-banenr">
        <div className="common-content">
          <h1>Frequently Asked Questions</h1>
        </div>
      </div>

      <div className="storylist">
        <div className="container">
          <div className="row">
            <div className="faqlisting col-md-12">
              <div className="row" id="faqs">
                {error && <p>{error}</p>}
                {currentFAQ.map((faq, index) => (
                  <div className="col-md-12 mb-3" key={index}>
                    <div className="card">
                      <div
                        className="card-header d-flex justify-content-between align-items-center"
                        onClick={() => toggleAccordion(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="faqq">{`Q: ${faq.question}`}</span>
                        <i
                          className={`fa-solid fa-angle-down arrow-icon ${
                            expandedIndex === index ? "rotate" : ""
                          }`}
                        ></i>
                      </div>
                      <div
                        className={`accordion-body ${
                          expandedIndex === index ? "open" : ""
                        }`}
                        ref={(el) => (elRefs.current[index] = el)}
                      >
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <span className="faqq" style={{ marginRight: "4px" }}>A: </span>
                          {faq?.answer &&
                            (() => {
                              try {
                                const rawContent = JSON.parse(faq.answer);
                                const html = draftToHtml(
                                  rawContent,
                                  null,
                                  null,
                                  (style) => {
                                    if (style.startsWith("color-")) {
                                      const color = style
                                        .replace("color-", "")
                                        .replace(/-/g, ",")
                                        .replace("rgb(", "rgb(");
                                      return `<span style="color:${color}">`;
                                    }
                                    if (style.startsWith("fontsize-")) {
                                      const size = style.replace(
                                        "fontsize-",
                                        ""
                                      );
                                      return `<span style="font-size:${size}px">`;
                                    }
                                    if (style.startsWith("fontfamily-")) {
                                      const font = style
                                        .replace("fontfamily-", "")
                                        .replace(/_/g, " ");
                                      return `<span style="font-family:${font}">`;
                                    }
                                    return null;
                                  }
                                );
                                return (
                                  <div
                                    dangerouslySetInnerHTML={{ __html: html }}
                                    style={{ display: "inline", paddingTop: "2px" }}
                                  />
                                );
                              } catch (err) {
                                console.error(
                                  "Failed to render FAQ answer:",
                                  err
                                );
                                return (
                                  <span className="text-danger">
                                    Could not load answer.
                                  </span>
                                );
                              }
                            })()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Pagination */}
          {/* <div className="pagination">
            <button onClick={handlePrev} disabled={currentPage === 1}>
              &laquo;
            </button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                className={currentPage === i + 1 ? 'active' : ''}
              >
                {i + 1}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              &raquo;
            </button>
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;
